var _style, _path, _line, _line2, _path2, _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 657.1 442.3",
    style: {
      enableBackground: "new 0 0 657.1 442.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:15;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M485,166.5v268.3H172v-387h277"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 232.5,
    y1: 374.8,
    x2: 424.5,
    y2: 374.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 232.5,
    y1: 327.8,
    x2: 424.5,
    y2: 327.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M358.6,229 M348.7,221.3L517.3,35l21,16.3L369.7,237.6 M348.7,221.3l-36.1,59.6l57-43.3 M538.1,12 c4.9-5.4,13.5-6.1,19.3-1.6c5.8,4.5,6.6,12.5,1.7,17.9 M538.1,12l-20.8,23 M538.3,51.3l20.8-23"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "551.9,115.7 559.5,129 573.4,136.3 559.5,143.6 551.9,156.9 544.3,143.6 530.4,136.3 544.3,129 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "619.4,53 627,66.3 640.9,73.6 627,80.8 619.4,94.1 611.8,80.8 597.9,73.6 611.8,66.3 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScript);
export default __webpack_public_path__ + "static/media/script.0e8e9a440b3a9301fe50b286406c9b48.svg";
export { ForwardRef as ReactComponent };